import { render, staticRenderFns } from "./textarea-widget.vue?vue&type=template&id=90e01c78&scoped=true&"
import script from "./textarea-widget.vue?vue&type=script&lang=js&"
export * from "./textarea-widget.vue?vue&type=script&lang=js&"
import style0 from "./textarea-widget.vue?vue&type=style&index=0&id=90e01c78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e01c78",
  null
  
)

export default component.exports